import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div `
    position: relative;
`;
const TooltipContainer = styled.div `
    background: ${({ theme }) => theme.colors.tooltip.bg};
    bottom: ${({ bottomSpacing }) => bottomSpacing || 5}px;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    padding: 12px;
    position: absolute;
    transition: opacity 1.1s;
    width: 100%;
`;
const Tooltip = ({ children, bottomSpacing, render, externalOpen }) => {
    // Tooltip can be activated by either hovering over a child element, or by setting the
    // externalOpen prop. spacing from the triggering element can be set by bottomSpacing
    const [isOpen, setIsOpen] = useState(externalOpen || false);
    return (jsxs(Wrapper, { children: [jsx(TooltipContainer, { isOpen: isOpen || externalOpen, bottomSpacing: bottomSpacing, children: render }), children && (jsx("span", { onMouseOver: () => setIsOpen(true), onMouseLeave: () => setIsOpen(false), children: children }))] }));
};

export { Tooltip };
